<div #sliderContent class="slider-content">
  <div class="primary-content">
    <ng-content select=".primary"></ng-content>
  </div>

  <div class="secondary-content">
    <ng-content></ng-content>
  </div>
</div>
